import logo from "src/assets/static/img/main/anten-logo-new-light.svg";

export const AppBoxShimmer: React.FC = () => (
    <div className="col-12 col-md-6 col-lg-4 col-xl-3">
        <div className="download-tile shimming">
            <img src={logo} alt="" />
            <span className="btn btn-submit disabled shimmer"></span>
        </div>
    </div>
);